import {
	CHECK_WHATSAPP_PLAN_STATUS,
	DISABLE_WHATSAPP_PLAN_CHECK,
	ADD_PACKAGE_STATUS_DETAILS,
} from '../actions/wabaIdDropdown.action';
import { IWhatsappLaunchState } from '../models/root.interface';

const initialState: IWhatsappLaunchState = {
	checkPlanStatus: false,
	whatsappPackageStatusDetails: {},
};

const whatsappLaunchReducer = (
	state: IWhatsappLaunchState = initialState,
	action: any
): IWhatsappLaunchState => {
	switch (action.type) {
		case CHECK_WHATSAPP_PLAN_STATUS:
			return {
				...state,
				checkPlanStatus: true,
			};
		case DISABLE_WHATSAPP_PLAN_CHECK:
			return {
				...state,
				checkPlanStatus: false,
			};
		case ADD_PACKAGE_STATUS_DETAILS:
			return {
				...state,
				whatsappPackageStatusDetails:
					action.whatsappPackageStatusDetails,
			};
		default:
			return state;
	}
};

export default whatsappLaunchReducer;
